import * as Sentry from '@sentry/react';

export const calculateTogo = (
    gameType: 75 | 80 | 90 | 30,
    cardNumbers: number[],
    patterns: number[][],
    matches: number,
    called: number[],
    hasFreeSpace: boolean
) => {
    const unavailable = {
        togo: Infinity,
        lastNumber: [] as number[],
        patternHit: false,
        available: false,
    };
    if (
        !Number.isInteger(matches) ||
        matches < 1 ||
        !Array.isArray(patterns) ||
        matches > patterns.length ||
        patterns.some(
            (pattern) =>
                !Array.isArray(pattern) ||
                pattern.length === 0 ||
                pattern.some(
                    (position) =>
                        !Number.isInteger(position) ||
                        position < 1 ||
                        position > cardNumbers.length ||
                        !Number.isFinite(cardNumbers[position - 1])
                )
        )
    ) {
        return unavailable;
    }
    let togo = 0;
    let lastNumber: number[] = [];
    let partsToGo: number[] = [];
    let numbersToGo: number[][] = [];
    let patternHit = false;

    patterns.forEach((pc, index) => {
        if (Array.isArray(pc)) {
            let currPatToGo = pc.length;
            let notCalled: number[] = [];
            pc.forEach((pcLoc) => {
                const $patternHit = called.indexOf(cardNumbers[pcLoc - 1]) >= 0;
                if ($patternHit) {
                    patternHit = true;
                }

                // for terna and quadra pattern, do not count the free space as a number to go
                if (
                    (cardNumbers[pcLoc - 1] === 0 &&
                        gameType === 90 &&
                        pc.length > 4) ||
                    (hasFreeSpace && gameType === 75 && pcLoc === 13) ||
                    $patternHit
                ) {
                    currPatToGo--;
                } else {
                    notCalled.push(cardNumbers[pcLoc - 1]);
                }
            });
            partsToGo.push(currPatToGo);
            numbersToGo.push(notCalled);
        } else {
            Sentry.captureException(`${patterns[index]} is not a valid array.`);
        }
    });

    partsToGo.sort((a, b) => a - b);

    for (let i = 0; i < matches; i++) {
        togo += partsToGo[i];
    }

    if (togo === 1) {
        lastNumber = numbersToGo
            .sort((a, b) => a.length - b.length)
            .filter((subArr) => subArr.length === 1 && subArr[0] !== 0)
            .map((subArr) => subArr[0]);
    }

    return { togo, lastNumber, patternHit, available: true };
};
